import { render, staticRenderFns } from "./EmpAge.vue?vue&type=template&id=1043b7f1"
import script from "./EmpAge.vue?vue&type=script&lang=js"
export * from "./EmpAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports